import { WprModelMngr } from './WprModelMngr';
import { WprValueMap } from './WprValueMap';

/**
 * ValueMap設定
 */
export class WprValueMapSetter {
	// private 変数  ------------------------------------------------------------
	private m_ModelMngr: WprModelMngr		= null;			// モデル管理機能
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(mngr: WprModelMngr) {
		this.m_ModelMngr = mngr;
	}
	// --------------------------------------------------------------------------

	// public メソッド	----------------------------------------------------------
	/**
	 * ValueMap登録
	 * @param id ValueMapのID
	 * @param vm ValueMap
	 */
	public addValueMap(id: string, vm: WprValueMap): void {
		this.m_ModelMngr.addValueMap(id, vm);
	}
	// --------------------------------------------------------------------------
}
